// Format frequency values for display
export const formatFrequency = (frequency) => {
  const freqMap = {
    15: 'Every 15 days',
    30: 'Every 30 days (Monthly)',
    45: 'Every 45 days',
    60: 'Every 60 days (Bi-monthly)',
  };
  
  return freqMap[frequency] || `Every ${frequency} days`;
};

export const getFrequencyLabel = (frequency) => {
  const labelMap = {
    15: '15 days',
    30: '30 days',
    45: '45 days', 
    60: '60 days',
  };
  
  return labelMap[frequency] || `${frequency} days`;
};